import { atom } from "jotai";

export const selectedFeaturedBundleIndexAtom = atom<number | "">("");
